import { cn } from '@/shared/lib/utils/classnames';

/**
 * Skeleton - Loading Placeholder Component
 *
 * 콘텐츠 로딩 중 표시할 스켈레톤 UI 컴포넌트
 * shadcn/ui 스타일 가이드 준수
 *
 * @example
 * ```tsx
 * <Skeleton className="h-4 w-full" />
 * <Skeleton className="h-12 w-12 rounded-full" />
 * ```
 */
export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {}

export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted/50 backdrop-blur-sm', className)}
      {...props}
    />
  );
}
